import React from 'react'
import IframeSection from '../../sections/IframeSection'
import { IFrameSliceProps } from './types'

const IFrameSlice: React.FC<IFrameSliceProps> = ({ slice }) => {
  const { i_title, i_is_main_heading, i_description, i_iframe: iframe } = slice.primary || {}

  return (
    <IframeSection
      heading={i_title?.text}
      isHeadingGreen
      isMainHeading={i_is_main_heading}
      headingPadding={['45px', '', '85px']}
      description={i_description?.html}
      inner="inners.primary"
      paddingTop={['40px', '', '54px']}
      paddingBottom={['40px', '', '80px']}
      bgColor="#F8FAFF"
      data={{ iframe }}
    />
  )
}

export default IFrameSlice
